import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c7f2a3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MEventoPeriodo__Legenda",
  "data-testid": "MEventoPeriodo__LegendaInicio"
}
const _hoisted_2 = {
  key: 0,
  class: "MEventoPeriodo__ModoDeRegistro"
}
const _hoisted_3 = {
  class: "MEventoPeriodo__Legenda",
  "data-testid": "MEventoPeriodo__LegendaFim"
}
const _hoisted_4 = {
  key: 0,
  class: "MEventoPeriodo__ModoDeRegistro"
}
const _hoisted_5 = {
  key: 1,
  class: "MEventoPeriodo__ModoDeRegistro"
}
const _hoisted_6 = {
  key: 0,
  class: "MEventoPeriodo__Repeticao",
  "data-testid": "MEventoPeriodo__Repeticao"
}

import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
import i18n from "@/i18n"
  import { Anulavel } from "@/types/gerais"
  import { ComputedRef, computed } from "vue"

  interface Props {
    eventoEstaEmAndamento?: boolean
    inicio: Anulavel<Date>
    fim?: Anulavel<Date>
    rotuloInicio?: string
    rotuloFim?: string
    modoRegistroInicio?: Anulavel<string>
    modoRegistroFim?: Anulavel<string>
    atividadeRecorrente?: Anulavel<boolean>
    bordarTranslucida?: boolean
    ehMarcacaoInicio?: boolean
    ehMarcacaoFim?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MEventoPeriodo',
  props: {
    eventoEstaEmAndamento: { type: Boolean },
    inicio: null,
    fim: null,
    rotuloInicio: { default: "" },
    rotuloFim: { default: "" },
    modoRegistroInicio: null,
    modoRegistroFim: null,
    atividadeRecorrente: { default: false },
    bordarTranslucida: { type: Boolean, default: false },
    ehMarcacaoInicio: { type: Boolean },
    ehMarcacaoFim: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { eventoEstaEmAndamento?: boolean, inicio: Anulavel<Date>, fim?: Anulavel<Date>, rotuloInicio: string, rotuloFim: string, modoRegistroInicio?: Anulavel<string>, modoRegistroFim?: Anulavel<string>, atividadeRecorrente: Anulavel<boolean>, bordarTranslucida: boolean, ehMarcacaoInicio?: boolean, ehMarcacaoFim?: boolean }

  const { t } = i18n.global

  

  const rotuloInicio = props.rotuloInicio || t("inicioPlanejado")
  const rotuloFim = props.rotuloFim || t("fimPlanejado")

  const { exibirDataPorExtenso } = usarDataHora()

  const validarTipoDeData = (data: Anulavel<Date>): boolean => {
    if (!data || data instanceof Date === false) {
      return false
    }

    return !isNaN(data.getTime())
  }

  const periodoDeInicio = computed(() => {
    if (validarTipoDeData(props.inicio) === false) {
      return "—"
    }

    return exibirDataPorExtenso(props.inicio!)
  }) as ComputedRef

  const periodoDeFim = computed(() => {
    if (validarTipoDeData(props.fim) === false || props.eventoEstaEmAndamento) {
      return "—"
    }

    return exibirDataPorExtenso(props.fim!)
  }) as ComputedRef
  const ehMarcacaoInicioEfetiva = computed(() => {
    if (props.ehMarcacaoInicio !== undefined) {
      return props.ehMarcacaoInicio
    }
    return Boolean(props.modoRegistroInicio)
  })

  const ehMarcacaoFimEfetiva = computed(() => {
    if (props.ehMarcacaoFim !== undefined) {
      return props.ehMarcacaoFim
    }
    return Boolean(props.modoRegistroFim)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["MEventoPeriodo", __props.atividadeRecorrente && '--DuasLinhas']),
    "data-testid": "MEventoPeriodo"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["MEventoPeriodo__Periodo MEventoPeriodo__Inicio", __props.bordarTranslucida && '--BordarTranslucida'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", null, [
          _createElementVNode("span", null, _toDisplayString(_unref(rotuloInicio)), 1),
          (__props.modoRegistroInicio)
            ? (_openBlock(), _createElementBlock("em", _hoisted_2, _toDisplayString(__props.modoRegistroInicio), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["MEventoPeriodo__DataPorExtenso", _unref(ehMarcacaoInicioEfetiva) ? 'MEventoPeriodo__DataPorExtenso--Marcacao' : 'MEventoPeriodo__DataPorExtenso--Planejado']),
        "data-testid": "MEventoPeriodo__DataPorExtensoInicio"
      }, _toDisplayString(_unref(periodoDeInicio)), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["MEventoPeriodo__Periodo MEventoPeriodo__Fim", __props.bordarTranslucida && '--BordarTranslucida'])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, [
          _createElementVNode("span", null, _toDisplayString(_unref(rotuloFim)), 1),
          (__props.modoRegistroFim)
            ? (_openBlock(), _createElementBlock("em", _hoisted_4, _toDisplayString(__props.modoRegistroFim), 1))
            : (__props.eventoEstaEmAndamento)
              ? (_openBlock(), _createElementBlock("em", _hoisted_5, _toDisplayString(_unref(t)('atividadeEmCurso')), 1))
              : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["MEventoPeriodo__DataPorExtenso", _unref(ehMarcacaoFimEfetiva) ? 'MEventoPeriodo__DataPorExtenso--Marcacao' : 'MEventoPeriodo__DataPorExtenso--Planejado']),
        "data-testid": "MEventoPeriodo__DataPorExtensoFim"
      }, _toDisplayString(_unref(periodoDeFim)), 3)
    ], 2),
    (__props.atividadeRecorrente)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)('atividadeRecorrente')), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})